import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var CheckmarkOutlineSVG = function CheckmarkOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.7 6.31a1 1 0 00-1.41 0L11.49 23.9l-7.78-8.14a1 1 0 00-1.41 0 1.08 1.08 0 000 1.48l8.47 8.87a1 1 0 001.44 0L29.7 7.79a1.08 1.08 0 000-1.48z"
  }));
};
CheckmarkOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CheckmarkOutlineSVG);